// @flow
import React, {type Node} from 'react'

import AgentBadge from 'components/people/AgentBadge'

import styles from './index.scss'

type Props = $ReadOnly<{
  name: string,
  isAgent: boolean,
}>

function PersonName({name, isAgent}: Props): Node {
  if (!isAgent)
    return name

  return (
    <React.Fragment>
      {name}
      <span className={styles.agentBadge} title={I18n.t('shared.agent')}>
        <AgentBadge className={styles.agentIcon} />
      </span>
    </React.Fragment>
  )
}

PersonName.defaultProps = {
  isAgent: false,
}

export default PersonName
